import Stack from '@eversports/klimt-primitives/legacy/Stack'
import Text from '@eversports/klimt-primitives/legacy/Text'

import { Localized } from '../../../localization/react'
import { PaymentServiceType, PaymentServiceTypeToNameMapping } from '../InvoiceHistory.types'

interface Props {
  usedPaymentServices: Array<PaymentServiceType>
  invoiceNumber: string
}

const UsedPaymentMethods = ({ usedPaymentServices, invoiceNumber }: Props) => {
  return (
    <Stack gap={1}>
      {usedPaymentServices.map((paymentService) => (
        <Text key={`${invoiceNumber}_${paymentService}`}>
          <Localized id={PaymentServiceTypeToNameMapping[paymentService]} />
        </Text>
      ))}
    </Stack>
  )
}

export default UsedPaymentMethods
